import React, { FocusEvent, useState } from 'react';
import { uniqueId } from 'es-toolkit/compat';

import { CheckboxGroupProps } from './types';
import { NoSSRComponent } from '@/migrated-widgets/table-map/utils/ssr';

function CheckboxGroup({ children: items, checkboxes = { className: '', width: 'w-full' } }: CheckboxGroupProps) {
  const [id] = useState<string>(uniqueId('checkboxgroup_'));

  const { className: checkboxesClassName, width: checkboxesWidth, ...checkboxesExtraProps } = checkboxes;
  function handleBlur(e: FocusEvent<HTMLElement>) {
    e.preventDefault();
  }
  return (
    <div onBlur={handleBlur} tabIndex={1} className={`z-20 ${id} relative inline-block text-left outline-none`}>
      {
        <div className={`flex gap-2 ${checkboxesWidth} ${checkboxesClassName ?? ''}`} role="menu" aria-orientation="horizontal" aria-labelledby="options-menu" {...checkboxesExtraProps}>
          {items}
        </div>
      }
    </div>
  )
}

export default NoSSRComponent<CheckboxGroupProps>(CheckboxGroup);